<template>
  <v-row>
    <v-col cols="12" md="12">
      <div class="card card-custom card-custom-center max-500">
        <div class="card-header">
          <div class="card-title">
            <h3 class="card-label">Payment Link</h3>
          </div>
        </div>
        <div class="card-body">
          <div class="payment-link-box">
            <p class="box-title">
              Link Created Successfully
            </p>
            <div class="feature-icon">
              <span class="icon-wrapper">
                <v-icon color="red darken-1" size="40px">
                  mdi-wallet-giftcard
                </v-icon>
              </span>
            </div>
            <div class="payment-info">
              <h3>
                {{ formatAmount(this.amount, this.currencyCode) }}
              </h3>
              <!-- <p class="sub-header mb-4">Sample Item</p> -->
              <h5 class="mb-8">
                <a :href="'/pay/' + linkParam" id="paymentLink" target="_blank"
                  >pay/{{ linkParam }}</a
                >
                <div class="hidden-field-content">
                  <input type="text"  :value="'https://quickpay.nicasiabank.com/pay/'+linkParam" id="myInput">
                </div>
              </h5>
              <!-- <input type="text" value="Hello World" id="myInput"> -->
            </div>

            <div class="payment-actions">
              <!-- <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    color="primary"
                    width="130px"
                    height="42px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left dark v-on="on">
                      mdi-share-variant-outline
                    </v-icon>
                    Share link
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in items" :key="index">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <ShareNetwork
                        :network="item.network"
                        :url="item.url"
                        :title="item.title"
                        :description="item.description"
                        :hashtags="item.hashtags"
                      >
                        {{ item.network }}
                      </ShareNetwork>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu> -->
              <v-btn
                depressed
                class="custom-secondary-btn"
                width="130px"
                height="42px"
                @click.prevent="copyPaymentLink"
              >
                <v-icon left dark>
                  mdi-content-copy
                </v-icon>
                Copy
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import Promise from "../../../../lib/mixins/ExtendedPromises";
import getLink from "../../../../repositories/getPaymentLink";
import { formatAmount } from '../../../../lib/currency'
export default {
  name: "GenerateLink",
  mixins: [Promise],
  data() {
    return {
      paymentLink: "",
      linkParam: "",
      showMenu: false,
      amount: "",
      items: [
        {
          network: "facebook",
          url: "https://www.nicasiabank.com/",
          title: "payment link",
          description: "payment link shared",
          hashtags: "linkpayment",
          icon: "mdi-facebook-messenger"
        },
        {
          network: "WhatsApp",
          url: "https://www.nicasiabank.com/",
          title: "payment link",
          description: "payment link shared",
          hashtags: "linkpayment",
          icon: "mdi-whatsapp"
        }
      ]
    };
  },
  mounted() {
    this.getUrlParam();
  },
  methods: {
    formatAmount,
    getUrlParam() {
      this.linkParam = this.$route.params.id;
      this.amount = this.$route.params.amount;
      this.currencyCode = this.$route.params.currencyCode;
    },
    copyPaymentLink() {
      var copyText = document.getElementById("myInput");
      copyText.select();
      copyText.setSelectionRange(0, 99999)
      document.execCommand("copy");
  
      this.$toasted.show('Link Copied',{
        icon:'check'
      })
    }
  }
};
</script>
<style scoped>
.hidden-field-content{
  opacity: 0;
}
</style>
